import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import { Actions } from "src/types";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import RichText from "@/components/editor/primitives/rich-text";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";

const StyledContainer = withViewportStyle("div")`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: ${rem(40)} 0;

  h2,
  h3,
  h4,
  p {
    margin-bottom: 0;
  }

  ${(props) => props.$viewport.mobile`
    padding: 0;
  `}
`;

const ButtonWrapper = withViewportStyle(StyledButtonContainer)`
  margin-top: ${rem(16)}
`;

export type ParagraphItemProps = {
  showCTA?: boolean;
};

export default function ParagraphItem(props: ParagraphItemProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <StyledContainer ref={connect} className="paragraph-item-sub-title">
      <Element
        id="paragraph-item-sub-title"
        is={RichText}
        text={`<h3>Brought to you by Opers</h3>`}
      />
      <Element
        id="paragraph-item-description"
        is={RichText}
        text={`<p>We’re here to help shape the future in a sustainable way. Our team is made of experts that help companies invest in renewable energy, and we support many initiatives to make the food industry more sustainable for our planet.</p>`}
      />
      {props.showCTA && (
        <ButtonWrapper>
          <Element
            id="cta-button"
            is={Button}
            text="Register"
            action={{
              kind: Actions.TicketSelector,
            }}
          />
        </ButtonWrapper>
      )}
    </StyledContainer>
  );
}

ParagraphItem.craft = {
  custom: {
    displayName: "Paragraph Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
